(function() {
  if (window.__qvInitialized === 7) return;
  window.__qvInitialized = 7;
  // 古いモーダル・ボタンを削除して再生成
  var _old = document.getElementById('qv-backdrop');
  if (_old) _old.remove();
  var _oldBtn = document.getElementById('qv-close');
  if (_oldBtn) _oldBtn.remove();

  var style = document.createElement('style');
  style.textContent = `
.qv-backdrop {
  position: fixed; inset: 0; z-index: 2147483647;
  background: rgba(28,26,23,.55);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  opacity: 0; pointer-events: none;
  transition: opacity .22s;
}
.qv-backdrop.is-open { opacity: 1; pointer-events: auto; }
.qv-modal {
  background: #fff; border-radius: 16px;
  width: 100%; max-width: 560px;
  max-height: 90vh; overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(28,26,23,.22);
  transform: translateY(12px);
  transition: transform .22s;
}
.qv-backdrop.is-open .qv-modal { transform: translateY(0); }
.qv-modal-header {
  position: sticky; top: 0; z-index: 10;
  display: flex; justify-content: flex-end; align-items: center;
  padding: 10px 12px;
  background: rgba(255,255,255,0.97);
  border-bottom: 1px solid #f0ebe4;
}
.qv-close {
  display: flex; align-items: center; gap: 5px;
  border: none; background: #3E2010; color: #fff; cursor: pointer;
  font-size: 13px; font-family: inherit; font-weight: 700;
  border-radius: 100px; padding: 7px 16px;
  transition: background .15s;
}
.qv-close:hover { background: #5a3018; }
.qv-body { display: grid; grid-template-columns: 1fr; gap: 0; }
@media (min-width: 480px) { .qv-body { grid-template-columns: 200px 1fr; } }
.qv-image-wrap { background: #EDE4D9; overflow: hidden; aspect-ratio: 1; }
@media (min-width: 480px) { .qv-image-wrap { border-radius: 0 0 0 16px; } }
.qv-img { width: 100%; height: 100%; object-fit: cover; display: block; }
.qv-img-placeholder { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: #b8a898; font-size: 48px; }
.qv-info { padding: 20px; }
.qv-product-link { display: block; color: inherit; text-decoration: none; }
.qv-title { font-size: 16px; font-weight: 700; color: #1c1a17; margin: 0 0 8px; line-height: 1.4; }
.qv-price { font-size: 18px; font-weight: 700; color: #1c1a17; margin-bottom: 16px; }
.qv-price s { color: #9a8878; font-weight: 400; font-size: 14px; margin-right: 6px; }
.qv-price-sale { color: #9A5A28; }
.qv-option-group { margin-bottom: 14px; }
.qv-option-name { font-size: 12px; font-weight: 700; color: #7a6e65; letter-spacing: .06em; text-transform: uppercase; margin: 0 0 8px; }
.qv-option-btns { display: flex; flex-wrap: wrap; gap: 6px; }
.qv-option-btn { border: 1.5px solid #d0c8be; background: #fff; border-radius: 8px; padding: 7px 14px; font-size: 13px; font-family: inherit; color: #1c1a17; cursor: pointer; transition: border-color .15s, background .15s; white-space: nowrap; }
.qv-option-btn:hover { border-color: #9A5A28; }
.qv-option-btn.is-selected { border-color: #9A5A28; background: #FDF5EC; color: #9A5A28; font-weight: 700; }
.qv-add-btn { width: 100%; padding: 14px; background: #3E2010; color: #fff; border: none; border-radius: 100px; font-size: 15px; font-family: inherit; font-weight: 700; cursor: pointer; transition: background .18s, opacity .18s; margin-top: 4px; }
.qv-add-btn:hover:not(:disabled) { background: #5a3018; }
.qv-add-btn:disabled { opacity: .55; cursor: not-allowed; }
.qv-add-btn.is-success { background: #4a7c59; }
.qv-add-btn[data-mode="link"] { background: #9A5A28; font-size: 14px; }
.qv-msg { font-size: 13px; color: #9A5A28; margin: 8px 0 0; text-align: center; min-height: 18px; }
.qv-view-link { display: block; text-align: center; font-size: 13px; color: #7a6e65; margin-top: 10px; text-decoration: underline; }
`;
  document.head.appendChild(style);

  var backdropEl = document.createElement('div');
  backdropEl.id = 'qv-backdrop';
  backdropEl.className = 'qv-backdrop';
  backdropEl.inert = true;
  backdropEl.setAttribute('aria-hidden', 'true');
  backdropEl.setAttribute('role', 'dialog');
  backdropEl.setAttribute('aria-modal', 'true');
  backdropEl.setAttribute('aria-labelledby', 'qv-title');
  backdropEl.innerHTML = '<div class="qv-modal" role="document"><div class="qv-modal-header"><button class="qv-close" id="qv-close" aria-label="閉じる">&#x2715; 閉じる</button></div><div class="qv-body"><div class="qv-image-wrap"><img id="qv-img" src="" alt="" class="qv-img" style="display:none"><div id="qv-img-placeholder" class="qv-img-placeholder">☕</div></div><div class="qv-info"><a id="qv-product-link" href="#" class="qv-product-link"><h2 id="qv-title" class="qv-title"></h2></a><div id="qv-price" class="qv-price"></div><div id="qv-options"></div><button id="qv-add-btn" class="qv-add-btn" type="button" disabled>カートに追加</button><p id="qv-msg" class="qv-msg"></p><a id="qv-view-link" href="#" class="qv-view-link">商品ページで詳しく見る →</a></div></div></div>';
  document.body.appendChild(backdropEl);

  var backdrop    = document.getElementById('qv-backdrop');
  var closeBtn    = document.getElementById('qv-close');
  var imgEl       = document.getElementById('qv-img');
  var imgHolder   = document.getElementById('qv-img-placeholder');
  var titleEl     = document.getElementById('qv-title');
  var priceEl     = document.getElementById('qv-price');
  var optionsEl   = document.getElementById('qv-options');
  var addBtn      = document.getElementById('qv-add-btn');
  var msgEl       = document.getElementById('qv-msg');
  var productLink = document.getElementById('qv-product-link');
  var viewLink    = document.getElementById('qv-view-link');

  var currentProduct  = null;
  var selectedOptions = {};
  var modalGeneration = 0;
  var returnFocus = null;
  var savedOverflow = '';
  var adding = false;
  var cartPending = false;
  var cartUncertain = false;

  function formatMoney(cents) { return '¥' + (cents / 100).toLocaleString('ja-JP'); }
  function stripHtml(str) { return (str||'').replace(/<br\s*\/?>/gi,' ').replace(/<[^>]*>/g,'').trim(); }
  function requiresSellingPlan(v) { return v && v.requires_selling_plan === true; }

  function updateAddBtn(v) {
    if (cartPending) { addBtn.disabled=true; addBtn.textContent='追加中...'; return; }
    if (cartUncertain) { addBtn.disabled=false; addBtn.textContent='カートを確認する →'; addBtn.dataset.mode='cart'; return; }
    if (adding) { addBtn.disabled = true; return; }
    addBtn.classList.remove('is-success');
    if (!v) { addBtn.disabled=true; addBtn.textContent='カートに追加'; addBtn.dataset.mode='add'; return; }
    if (requiresSellingPlan(v)) { addBtn.disabled=false; addBtn.textContent='商品ページで定期購入する →'; addBtn.dataset.mode='link'; }
    else if (!v.available) { addBtn.disabled=true; addBtn.textContent='売り切れ'; addBtn.dataset.mode='add'; }
    else { addBtn.disabled=false; addBtn.textContent='カートに追加'; addBtn.dataset.mode='add'; }
  }

  function optName(opt) { return typeof opt==='string'?opt:(opt.name||''); }
  function optValues(opt, idx, variants) {
    if (opt && typeof opt==='object' && Array.isArray(opt.values) && opt.values.length) return opt.values;
    var vals=[];
    variants.forEach(function(v){ var val=v['option'+(idx+1)]; if(val&&vals.indexOf(val)===-1) vals.push(val); });
    return vals;
  }

  function findVariant() {
    if (!currentProduct) return null;
    return currentProduct.variants.find(function(v) {
      return currentProduct.options.every(function(opt,i){ return v['option'+(i+1)]===selectedOptions[i]; });
    })||null;
  }

  function getSubscriptionPrice(v) {
    if (!currentProduct) return null;
    var groups = currentProduct.selling_plan_groups;
    if (!groups || !groups.length) return null;
    var plan = (groups[0].selling_plans || [])[0];
    if (!plan) return null;
    var adj = (plan.price_adjustments || [])[0];
    if (!adj) return null;
    if (adj.value_type === 'percentage') return Math.round(v.price * (1 - adj.value / 100));
    if (adj.value_type === 'fixed_amount') return v.price - adj.value;
    if (adj.value_type === 'price') return adj.value;
    return null;
  }

  function updatePrice(v) {
    if (!v) { priceEl.innerHTML=''; return; }
    if (requiresSellingPlan(v)) {
      var subPrice = getSubscriptionPrice(v);
      if (subPrice !== null && subPrice < v.price) {
        priceEl.innerHTML = '<s>'+formatMoney(v.price)+'</s> <span class="qv-price-sale">'+formatMoney(subPrice)+'</span><br><small style="font-size:11px;color:#6B6B6B;font-weight:400;">定期購入価格</small>';
      } else {
        priceEl.innerHTML = formatMoney(v.price);
      }
    } else if (v.compare_at_price && v.compare_at_price > v.price) {
      priceEl.innerHTML = '<s>'+formatMoney(v.compare_at_price)+'</s> <span class="qv-price-sale">'+formatMoney(v.price)+'</span>';
    } else {
      priceEl.innerHTML = formatMoney(v.price);
    }
  }

  function renderOptions(product) {
    optionsEl.innerHTML='';
    if (product.variants.length===1 && product.variants[0].title==='Default Title') return;
    product.options.forEach(function(opt,optIdx) {
      var name=optName(opt); var values=optValues(opt,optIdx,product.variants);
      var group=document.createElement('div'); group.className='qv-option-group';
      var label=document.createElement('p'); label.className='qv-option-name'; label.textContent=name;
      group.appendChild(label);
      var btns=document.createElement('div'); btns.className='qv-option-btns';
      values.forEach(function(val) {
        var btn=document.createElement('button'); btn.type='button'; btn.className='qv-option-btn'; btn.textContent=val;
        if (selectedOptions[optIdx]===val) btn.classList.add('is-selected');
        btn.addEventListener('click',function(){
          btns.querySelectorAll('.qv-option-btn').forEach(function(b){b.classList.remove('is-selected');});
          btn.classList.add('is-selected'); selectedOptions[optIdx]=val;
          var v=findVariant(); updatePrice(v); updateAddBtn(v); msgEl.textContent='';
        });
        btns.appendChild(btn);
      });
      group.appendChild(btns); optionsEl.appendChild(group);
    });
  }

  function openModal(handle) {
    var generation = ++modalGeneration;
    currentProduct = null; selectedOptions = {}; adding = false;
    returnFocus = document.activeElement;
    savedOverflow = document.body.style.overflow;
    backdrop.inert = false;
    backdrop.removeAttribute('aria-hidden');
    productLink.href = '/products/' + handle;
    viewLink.href = '/products/' + handle;
    imgEl.onload = null;
    imgEl.style.display='none'; imgHolder.style.display='flex';
    titleEl.textContent='読み込み中...'; priceEl.innerHTML=''; optionsEl.innerHTML='';
    addBtn.disabled=true; addBtn.textContent='カートに追加'; addBtn.classList.remove('is-success'); msgEl.textContent='';
    backdrop.classList.add('is-open'); document.body.style.overflow='hidden';
    closeBtn.focus();
    fetch('/products/'+handle+'.js').then(function(r){ if (!r.ok) throw new Error(); return r.json(); }).then(function(product){
      if (generation !== modalGeneration) return;
      if (!Array.isArray(product.variants) || !product.variants.length || !Array.isArray(product.options)) throw new Error();
      currentProduct=product;
      if (product.featured_image) {
        imgEl.src=product.featured_image; imgEl.alt=stripHtml(product.title);
        imgEl.onload=function(){ imgEl.style.display='block'; imgHolder.style.display='none'; };
      }
      titleEl.textContent=stripHtml(product.title);
      productLink.href='/products/'+handle; viewLink.href='/products/'+handle;
      var first=product.variants.find(function(v){return v.available;})||product.variants[0];
      selectedOptions={};
      product.options.forEach(function(opt,i){ selectedOptions[i]=first['option'+(i+1)]; });
      renderOptions(product); updatePrice(first); updateAddBtn(first); closeBtn.focus();
    }).catch(function(){ if (generation !== modalGeneration) return; currentProduct=null; titleEl.textContent='商品を読み込めませんでした'; msgEl.textContent='下の商品ページへのリンクからご確認ください。'; });
  }

  function closeModal() {
    ++modalGeneration;
    backdrop.classList.remove('is-open'); backdrop.inert=true;
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.style.overflow=savedOverflow; currentProduct=null; adding=false;
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
  }

  addBtn.addEventListener('click',function(){
    if (cartPending || adding) return;
    if (cartUncertain) { window.location.href='/cart'; return; }
    var v=findVariant(); if (!v) return;
    if (addBtn.dataset.mode==='link') { window.location.href=productLink.href; return; }
    if (!v.available) return;
    var generation = modalGeneration;
    adding=true;
    cartPending=true;
    addBtn.disabled=true; addBtn.textContent='追加中...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:v.id,quantity:1})})
    .then(function(r){ if(!r.ok) throw new Error(); return r.json(); })
    .then(function(){
      cartPending=false;
      document.dispatchEvent(new CustomEvent('cart:updated'));
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        document.querySelectorAll('[data-cart-count],.cart-count-bubble').forEach(function(el){el.textContent=cart.item_count;});
      }).catch(function(){});
      if (generation !== modalGeneration) { updateAddBtn(findVariant()); return; }
      addBtn.classList.add('is-success'); addBtn.textContent='✓ カートに追加しました！'; msgEl.textContent='';
      setTimeout(function(){ if (generation === modalGeneration) closeModal(); },1400);
    }).catch(function(){ cartPending=false; cartUncertain=true; adding=false; updateAddBtn(findVariant()); msgEl.textContent='追加できたか確認できませんでした。カートをご確認ください。'; });
  });

  closeBtn.addEventListener('click',closeModal);
  backdrop.addEventListener('click',function(e){ if(e.target===backdrop) closeModal(); });
  document.addEventListener('keydown',function(e){
    if (!backdrop.classList.contains('is-open')) return;
    if(e.key==='Escape') { e.preventDefault(); closeModal(); }
    if(e.key==='Tab') {
      var items=Array.from(backdrop.querySelectorAll('button:not(:disabled), a[href]')).filter(function(el){return el.getClientRects().length;});
      var first=items[0], last=items[items.length-1];
      if (!backdrop.contains(document.activeElement) || (!e.shiftKey && document.activeElement===last)) { e.preventDefault(); first.focus(); }
      else if(e.shiftKey && document.activeElement===first) { e.preventDefault(); last.focus(); }
    }
  });
  document.addEventListener('click',function(e){
    var trigger=e.target.closest('[data-quick-view-trigger]'); if(!trigger) return;
    e.preventDefault(); var handle=trigger.dataset.productHandle; if(handle) openModal(handle);
  });
})();
